// extracted by mini-css-extract-plugin
export default {"color1":"#00b7b3","green2":"#00fd94","green1":"#02ac51","red1":"#ff6f56","red2":"#fb453f","black1":"#1f1f1f","white1":"#dbd9d9"};